// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1GUp1","head":"Table_head__1Ip6x","col":"Table_col__2A162"};